import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Terms() {
  usePageMeta({
    title: "利用規約 | Biz-AI検定",
    description: "Biz-AI検定の利用規約です。サービスのご利用前に必ずお読みください。",
  });

  return (
    <div className="min-h-screen bg-[#faf6ee]">
      <header className="border-b border-[#c9bca7]/50 bg-[#f9f4e8]">
        <div className="max-w-3xl mx-auto px-6 py-4">
          <Link href="/" className="inline-flex items-center text-sm text-[#675a49] hover:text-[#2f1d15] transition-colors">
            <ArrowLeft className="w-4 h-4 mr-1" />
            トップに戻る
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-2xl font-bold text-[#4e2b1f] mb-8">利用規約</h1>

        <div className="space-y-8 text-[15px] text-[#4e2b1f] leading-relaxed">
          <p>
            この利用規約（以下「本規約」）は、合同会社AIM（以下「当社」）が提供するBiz-AI検定試験サービス（以下「本サービス」）の利用に関する条件を定めるものです。
            本サービスをご利用いただく際は、本規約に同意いただいたものとみなします。
          </p>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第1条（サービスの内容）</h2>
            <p>
              本サービスは、AI時代のビジネススキルを評価・認定するオンライン試験プラットフォームです。
              当社は、Biz-AI Associate試験およびBiz-AI Specialist試験（以下「各試験」）を提供します。
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第2条（受験資格）</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>Biz-AI Associate試験は、本サービスに会員登録を行ったすべての方が受験できます。</li>
              <li>Biz-AI Specialist試験は、Biz-AI Associate試験に合格し、かつ資格の有効期間内である方のみ受験できます。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第3条（資格の有効期間）</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>各試験の合格による資格の有効期間は、合格日から2年間とします。</li>
              <li>有効期間が満了した場合、資格は失効します。資格を維持するには再受験が必要です。</li>
              <li>Specialist資格が失効した場合、再取得にはAssociate試験の合格から改めて取得する必要があります。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第4条（受験料および支払い）</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>各試験の受験料は、申し込みページに表示された金額（税込）とします。</li>
              <li>支払いはクレジットカードによる即時決済とします。</li>
              <li>決済完了後の返金には原則として応じかねます。ただし、当社の責めに帰すべき事由によりサービスを提供できなかった場合はこの限りではありません。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第5条（禁止事項）</h2>
            <p className="mb-2">利用者は、本サービスの利用にあたり以下の行為を行ってはなりません。</p>
            <ol className="list-decimal list-inside space-y-2">
              <li>試験問題の複製、転載、第三者への漏洩</li>
              <li>不正な手段を用いた受験（代理受験、カンニング等）</li>
              <li>本サービスのシステムに対する不正アクセスまたは妨害行為</li>
              <li>他の利用者または第三者の権利を侵害する行為</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第6条（不正行為への対応）</h2>
            <p>
              当社は、不正行為が確認された場合、当該利用者の試験結果の無効化、資格の取消し、
              アカウントの停止等の措置を講じることができるものとします。
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第7条（サービスの変更・中断・終了）</h2>
            <p>
              当社は、事前の通知なくして本サービスの内容を変更、または本サービスの提供を中断・終了することができるものとします。
              これにより利用者に損害が生じた場合であっても、当社は一切の責任を負いません。
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第8条（免責事項）</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>当社は、本サービスの完全性、正確性、有用性等について保証するものではありません。</li>
              <li>通信環境やシステム障害に起因する試験の中断等について、当社は合理的な範囲で対応いたしますが、これにより生じた損害について一切の責任を負いません。</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第9条（規約の変更）</h2>
            <p>
              当社は、必要に応じて本規約を変更できるものとします。
              変更後の規約は、本サービス上に掲載した時点から効力を生じるものとします。
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">第10条（準拠法および管轄裁判所）</h2>
            <p>
              本規約は日本法に準拠し、本サービスに関する紛争については、札幌地方裁判所を第一審の専属的合意管轄裁判所とします。
            </p>
          </section>

          <div className="pt-4 text-sm text-[#8e7f69]">
            <p>制定日：2026年3月13日</p>
          </div>
        </div>
      </main>

      <footer className="border-t border-[#c9bca7]/50 py-8 px-6 bg-[#f9f4e8]">
        <div className="max-w-3xl mx-auto">
          <p className="text-[12px] text-[#8e7f69]">&copy; 2026 Biz-AI</p>
        </div>
      </footer>
    </div>
  );
}
